import { useState } from 'react'
import { ContentModal } from 'components/organisms/modals/content-modal'
import { PieImage, QRCodeWrapper } from 'components/common'
import SocialShareBlock from 'components/organisms/social-share-block'

interface ShareOfferModalProps {
	open: boolean
	setOpen: (open: boolean) => void
	offerId: string
	clubId: string
	avatarUrl: string
	shareQrCode?: boolean
}

export function ShareOfferModal({
	open,
	setOpen,
	offerId,
	clubId,
	avatarUrl,
	shareQrCode = false,
}: ShareOfferModalProps) {
	return (
		<ContentModal open={open} setOpen={setOpen} isModal title="Share Offer">
			<div className="relative flex flex-col items-center space-y-5">
				<div className="max-w-[304px] space-y-8">
					<div className="flex justify-center items-center">
						<PieImage
							className="w-[200px] h-auto rounded-2xl overflow-hidden flex-shrink-0"
							images={[avatarUrl]}
						/>
					</div>
					<div>
						<div className="text-white">Share with your community</div>
						<div className="mt-3 mb-6">
							<SocialShareBlock
								className="!justify-center"
								url={`${import.meta.env.VITE_SHARE_URL}/c/${clubId}/o/${offerId}`}
							/>
						</div>
						{shareQrCode && (
							<div className="mt-6">
								<QRCodeWrapper
									value={`${import.meta.env.VITE_SHARE_URL}/c/${clubId}/o/${offerId}`}
									size={100}
									qrClassName="bg-white p-3 rounded-2xl"
									downloadFileName={`offer-${offerId}`}
								/>
							</div>
						)}
					</div>
				</div>
			</div>
		</ContentModal>
	)
}

// ---------------------------------------------------------------------------
// Modal Manager integration
// ---------------------------------------------------------------------------

export interface ShareOfferModalManagedProps {
	offerId: string
	clubId: string
	avatarUrl: string
	shareQrCode?: boolean
}

declare module 'components/organisms/modals/modal-registry' {
	interface ModalRegistry {
		'share-offer': ShareOfferModalManagedProps
	}
}

export function ManagedShareOfferModal({
	onClose,
	...rest
}: ShareOfferModalManagedProps & { onClose: () => void }) {
	const [open, setOpen] = useState(true)

	const handleClose = () => {
		setOpen(false)
		setTimeout(onClose, 200)
	}

	return (
		<ShareOfferModal
			open={open}
			setOpen={(v: boolean) => { if (!v) handleClose() }}
			{...rest}
		/>
	)
}
